import { useStaticQuery, graphql } from "gatsby"

export default function useLayersImages() {
  return useStaticQuery(graphql`
    query {
      layersSvg: file(
        relativePath: {
          eq: "1_SOLUTIONS/Indoor Mapping/platform_infographic.svg"
        }
      ) {
        publicURL
      }
      iconLayer1: file(
        relativePath: {
          eq: "1_SOLUTIONS/Indoor Mapping/mobile/layer_1_cms.svg"
        }
      ) {
        publicURL
      }
      iconLayer2: file(
        relativePath: {
          eq: "1_SOLUTIONS/Indoor Mapping/mobile/layer_2_cms.svg"
        }
      ) {
        publicURL
      }
    }
  `)
}
